<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>部分工资发放使用说明:<br>
					<span>1、单号构成规则:201201+BFGZ+4位顺序号。系统生成,添加无效</span><br>
					<span>1、财务经理审核后,计入工资单。</span><br>
					<span>2、查询关键字:单号、申请人、状态、工资单。</span><br>
				</h5>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<!-- <template slot="slot_c_out_fee">
        <pre-select class="short0" ref="out_fee" @selectFunc="selectFunc1" v-bind:searchList="list_fee"
          :selectValue="sel_fee" />
      </template> -->
		</pre-base>

	</div>
</template>

<script>
	// import {
	// 	GetShort
	// } from '@/utils/localstore.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';
				this.init_data = JSON.stringify({
					"control": "salarypartpay",
					"title": "工资部分发放",
					"isTwo": "1",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "1",
					"sel_action": 'exp_kq_partpay_m',
					"upd_action": 'exp15_kq_partpay_m',
					"detail_part": "1",
					"detail_excelup": "0",
					"d_btn_more": "0",
					"d_sel_action": 'exp_kq_partpay_d',
					"d_upd_action": '_kq_partpay_d',
					"file_action": 'partpay_m',
					"p1": 'kq',
					"p2": 'partpay',
					"p3": '',
					"parm_sel": [
						{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"sel": "1"
						},
						{
							"name": "发放月份",
							"val": "",
							"key": "gz_date",
							"type": "month",
							"class": "long1",
							"sel": "2",
						},
						{
							"name": "发放人",
							"val": "",
							"key": "u_name2",
							"type": "select",
							"class": "long1",
							"sel_action": "data_alluser",
							"sel_name": "",
							"sel_val": {},
							"sel": "3"
						},
						{
							"name": "状态",
							"val": "",
							"key": "flag",
							"type": "select",
							"class": "long1",
							"sel_action": "data_flag",
							"sel_name": "",
							"sel_val": {},
							"sel": "4"
						},
						{
							"name": "工资单号",
							"val": "",
							"key": "sheet_gz",
							"type": "text",
							"class": "long1",
							"sel": "5"
						},
					],
					"parm": [{
							"name": "单号",
							"val": "",
							"key": "sheet_no",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "发放月份",
							"val": "",
							"key": "gz_month",
							"type": "month",
							"class": "long1",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "1"
						},
						{
							"name": "申请发放人",
							"val": "",
							"key": "u_name2",
							"type": "select",
							"class": "long1",
							"sel_action": "data_alluser",
							"sel_name": "",
							"sel_val": {},
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},
						{
							"name": "申请发放金额",
							"val": "",
							"key": "pay_amount",
							"type": "number",
							"class": "long1",
							"p": "1",
							"w": '0',
							"r": '0',
							"x": "1"
						},
						{
							"name": "财务确认",
							"val": "",
							"key": "amount_ok",
							"type": "label",
							"class": "black",
							"p": "0",
							"w": '0',
							"r": '0',
							"x": "2"
						},
						{
							"name": "相应月工资单号",
							"val": "",
							"key": "sheet_gz",
							"type": "label",
							"class": "black",
							"p": "0",
							"w": '0',
							"r": '0',
							"x": "2"
						},
						{
							"name": "相应月工资审核",
							"val": "",
							"key": "amount_gz",
							"type": "label",
							"class": "black",
							"p": "0",
							"w": '0',
							"r": '1',
							"x": "2"
						},
						{
							"name": "扣除金额",
							"val": "",
							"key": "amount_lost",
							"type": "label",
							"class": "black",
							"note": "每月扣除",
							"p": "0",
							"w": '0',
							"r": '0',
							"x": "2"
						},
						{
							"name": "应发金额",
							"val": "",
							"key": "amount_ok",
							"type": "label",
							"class": "black",
							"p": "0",
							"w": '0',
							"r": '0',
							"x": "2"
						},
						{
							"name": "审核发放",
							"val": "",
							"key": "amount_end",
							"type": "label",
							"class": "black",
							"p": "0",
							"w": '0',
							"r": '0',
							"x": "2"
						},
						{
							"name": "收款人姓名",
							"val": "",
							"key": "rec_user",
							"type": "text",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "收款人卡号",
							"val": "",
							"key": "rec_card",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						},
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long4",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "3"
						}
					],
					"parm_th": [{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "发放月"
						},
						{
							"name": "部门"
						},
						{
							"name": "申请发放人"
						},
						{
							"name": "申请发放金额"
						},
						{
							"name": "扣除金额"
						},
						{
							"name": "相应月工资单号"
						},

						{
							"name": "相应月工资审核"
						},
						{
							"name": "应发金额"
						},
						{
							"name": "审核发放"
						},
						{
							"name": "收款人姓名"
						},
						{
							"name": "收款人卡号"
						},
						{
							"name": "打款凭证"
						},
						{
							"name": "备注",
							"class": "long2"
						},	
						{
							"name": "附件"
						},
						{
							"name": "状态"
						},
						{
							"name": "修改人"
						},
						{
							"name": "浏览地址"
						},
						{
							"name": "存储地址"
						},
						{
							"name": "更新时间"
						}
					],
					"d_parm": [],
					"d_name": [
						{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "业务单号"
						},
						{
							"name": "扣款单号"
						},
						{
							"name": "费用名称"
						},
						{
							"name": "金额"
						},
						// {
						// 	"name": "卡号"
						// },
						{
							"name": "日期"
						},
						// {
						// 	"name": "是否开票"
						// },
						// {
						// 	"name": "公司支付"
						// },
						{
							"name": "备注",
							"class": "long2"
						},
						
						{
							"name": "修改人",
							"class": "short0"
						},
						// {
						// 	"name": "路径1"
						// },
						// {
						// 	"name": "路径2"
						// },
						{
							"name": "更新时间",
							"class": "long2"
						}
					]

				});



				// console.log(this.$refs);
				// this.$refs.mybase.load_data();
				// 解决偶尔第一次没有加载完成时再次 调用一下
				// var that = this;
				// this.$nextTick(function() {
				// 	that.$refs.mybase.load_data();
				// });

			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}



		}
	};
</script>
<style>
</style>